<p-toast [baseZIndex]="20000"></p-toast>
<p-dialog [modal]="true" [(visible)]="dialogVisible" [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
</p-dialog>
@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}
<div class="p-fluid p-grid">
  <div class="p-fluid p-grid">
    <div class="order-form-container">
      <form novalidate #formRef="ngForm" (ngSubmit)="onSubmit(formRef)">
        <p-tabs [tabindex]="activeTabIndex" (onChange)="handleTabChange($event)" value="0">


          <p-tablist>
            <p-tab value="0">Customer Data</p-tab>
            <p-tab value="1">Dispatch Data</p-tab>
          </p-tablist>

          <p-tabpanels>
            <div class="col-sm-18 right-align"
              [ngClass]="[isDispatchActive ? 'dispatch-padding' : '',  isCallertypeactive ? 'callertype-padding' : '']">
              <button pButton type="submit" class="save-button"
                [ngClass]="{'button-align':  ccrId.trim().length!==0}" [disabled]="isFormValid()">{{
              ccrId.trim().length===0 ?'Save':'Update'}}</button>
              <app-button label="Cancel" type="button" [outlined]="true" (click)="onPageLoad()">
              </app-button>
              @if (isOrderUpdate) {
                <app-button label="New" type="button" [outlined]="true"
                  (click)="newOrderEntry()">
                </app-button>
              }
            </div>
            <p-tabpanel value="0" header="Customer Data">
              <div class="container">
                <div class="left-panel" [ngClass]="{'NocallerType': !callerType}">
                  <div class="orderType-form">
                    <p class="centered-border-data">{{isOrderEntry}}</p>
                    <div class="border-panel headerType">
                      <div class="orderentrydiv">
                        <div class="col-sm-5 form-group"
                          [ngClass]="{'disabled-div': isOrderUpdate}">
                          <app-dropdown [options]="orderTypeDropdownOptions"
                            [(selectedValue)]="orderTypeSelectedValue"
                            (selectedValueChange)="onChangeOrderType($event)" label="Order Type:"
                            class="custom-width font-label-text fixed-width-dropdown"
                          [showLabel]="true" [showFloatingLabel]="false"></app-dropdown>
                        </div>
                      </div>
                    </div>
                    <div class="border-panel" [ngClass]="{'disabled-class': !isPageLoad}">
                      <div [ngClass]="{'disabled-div': isOrderUpdate}">
                        <p class="centered-border1">Customer Information</p>
                        <div class="orderentrydiv">
                          <div class="col-sm-4 form-group">
                            <label class="font-label-text required-label">Last Name: *</label>
                            <app-textinput [(ngModel)]="lastName" name="lastName"
                              (valueChange)="onLasttNameChange($event)" [maxlength]="25"
                              [required]="true" [placeholder]="'Last Name'"
                            #lastNameRef="ngModel"></app-textinput>
                            @if (lastNameRef.invalid && lastNameRef.touched) {
                              <div
                                class="text-danger Validation">
                                Enter Last Name.
                              </div>
                            }
                          </div>
                          <div class="col-sm-4 form-group">
                            <label class="font-label-text required-label">First Name: *</label>
                            <app-textinput [(ngModel)]="firstName" name="firstName"
                              (valueChange)="onFirstNameChange($event)" [maxlength]="20"
                              [required]="true" [placeholder]="'First Name'"
                            #firstNameRef="ngModel"></app-textinput>
                            @if (firstNameRef.invalid && firstNameRef.touched) {
                              <div
                                class="text-danger Validation">
                                Enter First Name.
                              </div>
                            }
                          </div>
                          @if (!isRightPanel) {
                            <div class="col-sm-4 form-group gender-type-allign"
                              >
                              <label> </label>
                              <app-radio-button [options]="gender" name="gender"
                                [(ngModel)]="genderValue" (onClick)="onGenderChange($event)"
                                class="font-label-text">
                              </app-radio-button>
                            </div>
                          }
                        </div>
                        <div class="orderentrydiv">
                          <div class="col-sm-4 form-group">
                            <label class="font-label-text required-label">House Number:
                            *</label>
                            <app-textinput [(ngModel)]="houseNumber" name="houseNumber"
                              (valueChange)="onHouseNoChange($event)" [maxlength]="10"
                              [required]="true" [placeholder]="'House Number'"
                            #houseNoRef="ngModel"></app-textinput>
                            @if (houseNoRef.invalid && houseNoRef.touched) {
                              <div
                                class="text-danger Validation">
                                Enter House Number.
                              </div>
                            }
                          </div>
                          <div class="col-sm-4 form-group">
                            <label class="font-label-text required-label">Street: *</label>
                            <app-textinput [(ngModel)]="street" name="street"
                              (valueChange)="onStreetChange($event)" [required]="true"
                              [placeholder]="'Street'" #streetRef="ngModel"
                            [maxlength]="20"></app-textinput>
                            @if (streetRef.invalid && streetRef.touched) {
                              <div
                                class="text-danger Validation">
                                Enter Street Address.
                              </div>
                            }
                          </div>
                        </div>
                        <div class="orderentrydiv">
                          @if (isCityText) {
                            <div class="col-sm-4 form-group">
                              <label class="font-label-text required-label">City: *</label>
                              <app-textinput [(ngModel)]="cityValue" name="cityValue"
                                [maxlength]="25" (valueChange)="onCityTextChange($event)"
                                [required]="true" [placeholder]="'City'"
                              #cityRef="ngModel"></app-textinput>
                              @if (cityRef.invalid && cityRef.touched) {
                                <div
                                  class="text-danger Validation">
                                  Enter City Name.
                                </div>
                              }
                            </div>
                          }
                          @if (!isCityText) {
                            <div class="col-sm-4 form-group" [ngClass]="{'disabled-class': !isCity}"
                              >
                              <label class="font-label-text required-label">City: *</label>
                              <app-dropdown [options]="CityDropdownOptions"
                                (selectedValueChange)="OnCityChanged($event)" placeholder=""
                                [(selectedValue)]="citySelectedValue"
                                class="custom-width font-label-text fixed-width-dropdown"
                                [showLabel]="true" [showFloatingLabel]="false" [required]="true"
                                [validationName]="'City'" [isFormSubmitted]="isFormSubmitted"
                              class="custom-width"></app-dropdown>
                            </div>
                          }
                          <div class="col-sm-2 form-group dropdown-container">
                            <label class="font-label-text required-label">State: *</label>
                            <app-dropdown [options]="StateDropdownOptions"
                              [(selectedValue)]="stateSelectedValue"
                              (selectedValueChange)="OnStateChanged($event)" placeholder=""
                              class="fixed-width-dropdown custom-width" [showLabel]="true"
                              [showFloatingLabel]="false" [validationName]="'State'"
                              [isFormSubmitted]="isFormSubmitted"
                            [required]="true"></app-dropdown>
                          </div>
                          <div class="col-sm-2 form-group">
                            <label class="font-label-text">ZIP:</label>
                            <app-textinput [(ngModel)]="zip" name="zip"
                              (valueChange)="onZipChange($event)" [maxlength]="10"
                            [placeholder]="'Zip'" #zipRef="ngModel"></app-textinput>
                            @if (isZipCodeValidate) {
                              <div class="text-danger Validation">
                                Enter Valid Zip.
                              </div>
                            }
                          </div>
                        </div>
                        <div class="orderentrydiv">
                          <button type="button"
                            class="btn btn-link ml-2 p-0 outline-0 removeshadow city-link"
                          (click)="cityClick()">Create City for TBD District</button>
                        </div>
                        <div class="flex">
                          @if (!showDiv) {
                            <div class="form-group flex flex-col w-full md:!1/4">
                              <label class="font-label-text required-label">Telephone: *</label>
                              <app-textinput [(ngModel)]="phone" name="phone"
                                class="font-label-text" (valueChange)="onPhoneChange($event)"
                                maxlength="14" [appPhoneFormat]="true" [required]="true"
                              #phoneRef="ngModel" [placeholder]="'Telephone'"></app-textinput>
                              @if (phoneRef.invalid && phoneRef.touched) {
                                <div
                                  class="text-danger Validation">
                                  Eneter Phone Number.
                                </div>
                              }
                              @if (isPhoneNoValidate) {
                                <div class="text-danger Validation">
                                  Enter Valid Phone Number.
                                </div>
                              }
                            </div>
                          }
                          @if (showDiv) {
                            <div class="form-group flex flex-col  w-full md:!1/5">
                              <label class="font-label-text required-label">Safe Phone: *</label>
                              <app-textinput [(ngModel)]="phone" name="phone"
                                class="font-label-text" (valueChange)="onPhoneChange($event)"
                                maxlength="14" [appPhoneFormat]="true" [required]="true"
                                [placeholder]="'Safe Phone'"
                              #phoneRef="ngModel"></app-textinput>
                              @if (phoneRef.invalid && phoneRef.touched) {
                                <div
                                  class="text-danger Validation">
                                  Enter Phone Number.
                                </div>
                              }
                              @if (isPhoneNoValidate) {
                                <div class="text-danger Validation">
                                  Enter Valid Phone Number.
                                </div>
                              }
                            </div>
                          }
                          <div class="form-group flex flex-col  w-full md:!1/5"
                            ngClass="{'ml-2': isSsnEnable }">
                            <label class="font-label-text">Extension:</label>
                            <app-textinput [(ngModel)]="extension" name="extension"
                              class="font-label-text" (valueChange)="onExtNoChange($event)"
                              maxlength="5" [placeholder]="'Extension'"
                            #extRef="ngModel"></app-textinput>
                          </div>
                          <div class="Flex flex-col form-group  w-full md:!w-1/5"
                            ngClass="{'ml-2': isSsnEnable }">
                            <label class="font-label-text">Contract Account Nbr:</label>
                            <app-textinput [(ngModel)]="accountno" name="accountno"
                              class="font-label-text" (valueChange)="onAccNoChange($event)"
                              maxlength="10" [placeholder]="'Contract Account Nbr'"
                            #accountRef="ngModel"></app-textinput>
                          </div>

                          @if (isSsnEnable) {
                            <div class="col-sm-3 form-group ml-2">
                              <label class="font-label-text">Social Security Nbr:</label>
                              <app-textinput [(value)]="ssn" (valueChange)="onSSNChange($event)"
                                appSsnMasker maxlength="11"
                                [placeholder]="'Social Security Nbr'"
                              [applySsnMasker]="true"></app-textinput>
                              @if (isSsnValidate) {
                                <div class="text-danger Validation">
                                  Enter Valid SSN Number.
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="orderentrydiv">
                          <div class="col-sm-12 form-group">
                            <label class="font-label-text">Customer Request Information:</label>
                            <br>
                              <app-text-area placeholder="Enter Customer Request Information."
                                name="customerRequest" [(ngModel)]="customerRequest"
                                (change)="oncustomerRequestChange($event)" [cols]="69">
                              </app-text-area>
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (isReconnect) {
                        <div class="border-panel">
                          <p class="centered-border1">Reconnect Information</p>
                          <div class="orderentrydiv">
                            <div class="col-sm-4 form-group">
                              <app-reconnect [reconnectDate]="reconnectDate"
                              (formValuesChange)="handleFormValuesChange($event)"></app-reconnect>
                            </div>
                          </div>
                          <br>
                          </div>
                        }
                        @if (isCallCheckListEnable) {
                          <div class="border-panel">
                            <app-call-checklist [isEnableLeaked]="isEnableLeaked"
                              [isEmerComments]="isEmerComments" [isLeakageEnabled]="isLeakageEnabled"
                              [emergencies]="emergencies" [isFirstOrderNotice]="isFirstOrderNotice"
                              (formValuesChange)="handleCallChecListFormValues($event)"
                              (formStatusChange)="handleCallChecListFormValidity($event)"
                              [OrderTypeValue]="OrderTypeValue"
                              (callerTypeChanged)="handleCallerTypeChange($event)">
                            </app-call-checklist>
                          </div>
                        }
                        @if (['TRANSFER'].includes(orderTypeSelectedValue)) {
                          <div [ngClass]="{'disabled-class': !isPageLoad}"
                            >
                            <app-move-out-form #moveOutForm
                              (formDataChange)="onFormMoveOutDataChange($event)"
                            [existingData]="customerOldSvcAddressRecord"></app-move-out-form>
                            <div>
                              <app-move-in-form #moveInForm
                                (formDataChange)="onFormMoveInDataChange($event)"
                              [existingData]="customerNewServiceRecord"></app-move-in-form>
                            </div>
                          </div>
                        }
                        @if (['MOVE-IN', 'NEW ACCOUNT'].includes(orderTypeSelectedValue)) {
                          <div [ngClass]="{'disabled-class': !isPageLoad}"
                            >
                            <app-move-in-form #moveInForm (formDataChange)="onFormMoveInDataChange($event)"
                            [existingData]="customerNewServiceRecord"></app-move-in-form>
                          </div>
                        }
                        @if (orderTypeSelectedValue === 'MOVE-OUT') {
                          <div [ngClass]="{'disabled-class': !isPageLoad}"
                            >
                            <app-move-out-form #moveOutForm
                              (formDataChange)="onFormMoveOutDataChange($event)"
                            [existingData]="customerOldSvcAddressRecord"></app-move-out-form>
                          </div>
                        }
                      </div>
                    </div>
                    @if ((customerChecked || passerByChecked || otherChecked)) {
                      <div class="right-panel">
                        <div class="check-header">Advisories:</div>
                        <div class="check-header" #advisoryDiv>
                          @for (item of advisoriesList; track item; let i = $index) {
                            <p>
                              <input type="checkbox" [(checked)]="item.checked"
                                (change)="onAdvisoriesChange($event)">
                                <span [innerHTML]="sanitizeHtml(item.Advisories)"></span>
                              </p>
                            }
                            <label>
                              <input type="checkbox" [(ngModel)]="isDisclosureChecked" />
                              <span class="advisories-type-disclosure">Disclosure-I certify that I have given
                              all advisories to the caller as presented.</span>
                            </label>
                            <p></p>
                            <div>
                              <button type="button" class="btn btn-secondary ml-2"
                              (click)="openConfirmationPopup()">Call Disconnected</button>
                            </div>
                            <br>
                            </div>
                          </div>
                        }
                      </div>
                    </p-tabpanel>
                    <p-tabpanel value="1" header="Dispatch Data">
                      <div class="container">
                        <div class="dispatch-form">
                          <div class="border-panel">
                            <app-dispatch-data (formValuesChange)="handleDispatchFormValues($event)"
                              [totalNumRecords]="totalNumRecords" [historyLogs$]="historyLogs$"
                              [dispatch]="dispatch">
                            </app-dispatch-data>
                          </div>
                        </div>
                      </div>
                    </p-tabpanel>
                  </p-tabpanels>

                </p-tabs>
              </form>
            </div>
          </div>
        </div>
        <div class="spacer"></div>